<template>
    <div class="container">
        <!--<a :href="'/customer/'+this.customer_id"> << Atgal </a>-->
        <div class="card">
            <div class="card-header">
                Pardavimas
                <button class="btn btn-danger float-right" @click="deleteSale" onclick="return(false)">Trinti</button>
            </div>
            <div class="card-body" @mouseover="onFocus">
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <label for="eq_id">Įranga</label>

                        <v-select v-if="equipment" class="vue-select2" id="eq_id" name="select2"
                                  :options="equipment" label="name"
                                  :model.sync="new_equipment"
                                  v-model="new_equipment"
                                  :searchable="true" language="en-US">
                        </v-select>
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="eq_qty">Kiekis</label>
                        <input id="eq_qty" @focus="onFocus" @keyup="enter_submit" class="form-control"
                               v-model="new_equipment_qty"
                               type="text">
                    </div>
                    <div class="col-6 col-md-3">
                        <label for="">&nbsp;</label>
                        <button @click="add_equipment_to_offer" class="form-control btn btn-outline-success">Pridėti
                        </button>
                    </div>
                </div>
            </div>
            <div id="main-card" class="card-body">
                <div class="row border py-1" v-for="(se, i) in selected_equipment">

                    <div v-if="!se.equipment_text" @click="deleteOldSelected(i, se)" @mouseover="onFocus"
                         class="col-1 text-danger font-weight-bold">-
                    </div>
                    <div class="col-10 col-md-4" v-if="!se.equipment_id">{{ se.type.name }} <span class="small"
                                                                                                  title="Įrangos tipo nuolaida">(nuol. pagal tipą {{ se.type_discount }}%)</span><br>
                        {{ se.name }}
                        <br>Kaina: {{
                            se.price
                        }} &euro;
                    </div>
                    <div class="col-12 col-md-1 mb-4 mb-md-0" v-if="!se.equipment_id">{{ se.pivot.quantity }} vnt.
                    </div>

                    <div class="col-12 col-md-6" v-if="!se.equipment_text">
                        <div class="row">

                            <div class="col-6 col-md-2">
                                {{ (se.pivot.price ? se.pivot.price : se.price) }} &euro;
                                <span v-if="se.pivot.price != se.price" class="fa fa-arrow-down text-danger"></span><br>
                                <span class="small"
                                      title="Skirtumas tarp klientui priklausančios kainos ir išsaugotos šiame pardavime"> {{
                                        ((se.pivot.price ? se.pivot.price : se.price) - (se.price - (se.price / 100 * (se.discount ? se.discount : 0))).toFixed(4)).toFixed(4)
                                    }} </span>
                            </div>
                            <div class="col-6 col-md-4">
                                <div class="form-group small">
                                    <!--<label for="">Kliento nuol.</label>-->
                                    <div class="input-group">
                                        <input class="form-control" type="text" :id="'discount' + se.id"
                                               @focus="onFocus" v-model="se.discount">
                                        <div class="input-group-append">
                                            <div class="input-group-text">%</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3" @dblclick="edit_pivot_price">
                                <div class="input-group">
                                    <input class="form-control bg-secondary text-white" :id="se.id"
                                           title="Kaina po nuolaidos. Jeigu raudona, vadinasi kaina nėra išsaugota"
                                           :class="getClass(se.pivot.price, (se.price - (se.price / 100 * (se.discount ? se.discount : 0))).toFixed(4))"
                                           :value="(se.price - (se.price / 100 * (se.discount ? se.discount : 0))).toFixed(4)">
                                    <div class="input-group-append" :id="se.id" @click="edit_pivot_price">
                                        <span class="input-group-text" :id="se.id"><span :id="se.id"
                                                                                         class="fa fa-pencil small"></span></span>
                                    </div>
                                </div>


                            </div>

                            <div class="col-6 col-md-3" style="display: none;" :id="'price-edit' + se.id">
                                <input class="form-control bg-warning text-dark" v-model="se.pivot.price"
                                       @keyup="setPriotity(se)"
                                       title="Kaina po nuolaidos. Jeigu raudona, vadinasi kaina nėra išsaugota"/>


                            </div>

                            <div class="col-6 col-md-3">
                                <span class="form-control bg-success-light text-dark small text-sm-center small"
                                      title="Pozicijos suma po nuolaidos. Jeigu raudona, vadinasi kaina nėra išsaugota"
                                      :class="getClass(se.pivot.price, (se.price - (se.price / 100 * (se.discount ? se.discount : 0))).toFixed(4))">
                                        {{
                                        ((se.price - (se.price / 100 * (se.discount ? se.discount : 0))).toFixed(4) * se.pivot.quantity).toFixed(4)
                                    }}
                                </span>
                            </div>

                        </div>


                    </div>


                    <div v-if="se.equipment_text" @click="deleteSelected(i, se.price, se.quantity)" class="col-1">-
                    </div>
                    <div class="col-11 col-md-6" v-if="se.equipment_text">{{ se.equipment_text }} -- {{ se.quantity }}
                        vnt.
                    </div>

                </div>

                <div class="form-row m-2">
                    <div class="col-12 col-lg-3">
                        <div class="form-group">
                            <label for="price">Suma be PVM <span class="btn btn-outline-secondary btn-sm small"
                                                                 @mouseover="renew_total">parodyti su PVM</span></label>
                            <div class="input-group">
                                <input id="price" readonly @focus="onFocus" class="form-control" type="text"
                                       placeholder="Parodyti su PVM" :value="total">
                                <div class="input-group-append">
                                    <div class="input-group-text">€</div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="col-12 col-lg-3">
                        <div class="row">
                            <div class="col-12">
                                <label for="cust_id">Klientas</label>
                                <!--<div class="input-group">-->
                                <v-select v-if="customers" class="vue-select2" id="cust_id" name="select2"
                                          :options="customers" label="name"
                                          @search:blur="onFocus"
                                          :model.sync="selected_customer"
                                          v-model="selected_customer"
                                          :searchable="true" language="en-US">
                                </v-select>
                            </div>

                        </div>

                        <div class="row mt-1">
                            <div class="col-12">
                                <label class="small" for="">Taikyti nuolaidą:</label><br>
                                <div class="btn-group">
                                    <button class="btn btn-outline-success btn-sm" @click="set_discount_by_type">pagal
                                        tipą
                                    </button>
                                    <button class="btn btn-outline-secondary btn-sm"
                                            @click="set_discount_by_last_price">paskutinę kainą
                                    </button>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="col-12 col-md-6 col-lg-6 my-2 my-lg-0">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-12 col-lg-3">Mokėjimai</div>
                                    <div class="col-12 col-lg-9">
                                        <div class="form-row small">
                                            <div class="col small">

                                                <div class="input-group">
                                                    <select class="form-control p-1" name="payment_source_id"
                                                            id="payment_source">

                                                        <option v-for="(ps,i) in this.payment_sources " :value="ps.id">
                                                            {{ ps.name }}
                                                        </option>

                                                    </select>
                                                    <input id="payment_date" :data-sale="this.sid"
                                                           class="form-control" type="text"
                                                           :value="formatDate(new Date().toLocaleString('lt-LT'))">
                                                    <input id="payment_amount" data-offer="sale" :data-sale="this.sid"
                                                           class="form-control" type="text">
                                                    <div class="input-group-append">
                                                        <div class="input-group-text">&euro;</div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-2">
                                                <button class="payment_save form-control"><span
                                                    class="fa fa-save"></span></button>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>

                            <div class="card-body" data-key="offers|id">


                                <!--@foreach($o['payments'] as $p)-->

                                <div v-for="payment in payments" class="row text-danger" data-key="">
                                    <div class="col-4">{{ new Date(payment.created_at).toLocaleString() }}</div>
                                    <div class="col-2">{{ payment.amount }} &euro;</div>
                                    <div class="col-2">
                                        <a :href="'/kpo/'+payment.id" v-if="payment.payment_source_id == 2"
                                           class="btn btn-outline-success btn-xs small">KPO</a>
                                    </div>
                                    <div class="col-2">

                                    </div>


                                    <div v-if="uid == 1 || uid == 4" class="col-2">


                                        <span v-if="payment.approved == false" class="text-small small">Tvirt. mok. lange</span>
                                    </div>


                                </div>


                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div class="card-footer">

                <div class="row">
                    <div class="col-6 col-md-4 my-2">
                        <button id="update_offer" @click="update_offer" class="btn btn-outline-success border">Saugoti
                        </button>
                    </div>


                    <div class="col-12 col-md-4 my-2">
                        <div class="btn-group float-right">

                            <a class="btn btn-outline-success btn-sm"
                               :href="'/storage/pardavimai/'+ this.sid +'/saskaita_'+this.did+'.pdf'">Sąskaita -
                                {{ this.did }}
                                PDF
                                <span
                                    class="fa fa-file"></span></a>

                            <a :href="'/test_invoice/sale/' + this.sid " class="btn btn-outline-success btn-sm">Išankstinė
                                <span
                                    class="fa fa-file"></span></a>
                            <a :href="'/invoice/sale/' + this.sid " class="btn btn-outline-success btn-sm">Generuoti
                                sąsk. <span
                                    class="fa fa-file-plus"></span></a>
                        </div>
                    </div>
                    <div class="col-6 col-md-2 my-2">
                        <div class="btn-group float-lg-right">
                            <a class="btn btn-outline-success btn-sm ml-lg-2"
                               :href="'/customer/'+ this.selected_customer.id">Rodyti
                                klientą</a>
                        </div>
                    </div>
                </div>


            </div>

        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
    name: "EditSale",
    props: ['sid', 'uid', 'did'],
    components: {
        vSelect,
    },
    data() {
        return {
            power: '',
            price: '',
            discount: 0,
            payment1: '',
            percent1: '',
            payment2: '',
            percent2: '',
            payment3: '',
            percent3: '',
            equipment: '',
            usage: '',
            new_equipment: '',
            new_equipment_qty: '',
            selected_equipment: [],
            equipment_to_delete: [],
            total: '',
            id: '',
            data_loading: true,
            payment_sources: [],
            customer_id: '',
            customers: '',
            selected_customer: '',
            payments: '',
            last_prices: ''
        }
    },
    watch: {

        price: function (val) {
            if (this.data_loading == false) {
                if (val > 999) {
                    if (this.payment1) {
                        this.payment1 = Math.round((((val - this.discount) / 100) * this.percent1) / 100) * 100;
                    }
                    if (this.payment3) {
                        this.payment3 = Math.round((((val - this.discount) / 100) * this.percent3) / 100) * 100;
                    }
                    if (this.percent1 && this.percent3) {
                        this.payment2 = (this.price - this.discount) - (this.payment1 + this.payment3);
                    }
                }
            }
        },

        selected_customer: function () {
            if (this.data_loading == false) {
                this._data.id = this.$props.sid;
                console.log(this._data);
                $('#update_offer').addClass('btn-danger text-warning').text('Saugoti pakeitimus');

                axios.post('/update_sale_customer', this._data).then(res => {
                    // alert('Po kliento pakeitimo, būtina išsaugoti pardavimą!')
                    window.location.reload();
                }).catch(error => {
                    let array = {'msg': error.response.data.message};
                    axios.post('/mail_error', array).then(res => {
                        console.log(res.data);
                    });
                    window.location.replace('/404');
                });
            }
        },

        selected_equipment: {
            handler(val, oldVal) {
                if (this.data_loading === false) {
                    console.log('etd ' + this.data_loading);
                    $('#update_offer').addClass('btn-danger text-warning').text('Saugoti pakeitimus');
                    $('#main-card').addClass('border border-5 border-danger');
                }
            },
            deep: true
        },

        equipment_to_delete: {
            handler(val, oldVal) {
                if (this.data_loading === false) {
                    console.log('etd');
                    $('#update_offer').addClass('btn-danger text-warning').text('Saugoti pakeitimus');
                    $('#main-card').addClass('border border-5 border-danger');
                }
            },
            deep: true
        },

    },
    mounted() {
        console.log('mount');
        axios.get('/get_equipment').then(res => {
            this.equipment = res.data
        });

        axios.get('/get_customers').then(res => {
            this.customers = res.data
        });

        axios.get('/get_sale/' + this.$props.sid).then(res => {
            console.log(res.data);
            this.customer_id = res.data.customer_id;
            this.price = res.data.price;
            this.total = res.data.total;
            this.discount = res.data.discount;

            this.payment1 = res.data.payment1;
            this.payment2 = res.data.payment2;
            this.payment3 = res.data.payment3;

            this.percent1 = res.data.percent1;
            this.percent2 = res.data.percent2;
            this.percent3 = res.data.percent3;


            // this.power = res.data.power;
            this.selected_customer = res.data.customer;
            this.selected_equipment = res.data.equipment;
            this.payment_sources = res.data.payment_sources;
            this.last_prices = res.data.last_prices;
            this.payments = res.data.payments;
            //

        });

        setTimeout(() => {
            this.onFocus()
        }, 500);
    },
    created() {
        console.log('created');

    },
    methods: {
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;
            return [year, month, day].join('-');
        },
        add_equipment_to_offer() {
            this.selected_equipment.push({
                equipment_id: this.new_equipment.id,
                equipment_text: this.new_equipment.name,
                quantity: this.new_equipment_qty,
                price: this.new_equipment.price
            });
            this.price = Number(this.price) + (Number(this.new_equipment.price) * Number(this.new_equipment_qty));
            this.percent1 = this.percent3 = '';
            console.log(this.new_equipment.power);
            if (this.new_equipment.power > 0 && this.new_equipment.equipment_type_id == 1) {
                this.power = (Number(this.power) + Number(this.new_equipment.power) * Number(this.new_equipment_qty)).toFixed(4);
            }
            this.new_equipment_qty = '';
        },
        deleteSelected(i, price, quantity) {
            this.selected_equipment.splice(i, 1);
            this.price = Number(this.price) - (Number(price) * Number(quantity));
        },
        deleteOldSelected(i, obj) {
            console.log(obj.pivot.equipment_id + ' ' + obj.pivot.sale_id);
            this.equipment_to_delete.push({'equipment_id': obj.pivot.equipment_id, 'sale_id': obj.pivot.sale_id});
            this.selected_equipment.splice(i, 1);


        },
        update_offer() {
            console.log(this._data);

            // this.total = Number(this.price) - Number(this.discount);
            this.id = this.$props.sid;
            this.user_id = this.$props.uid;
            this.customer_id = this.selected_customer.id;
            this.percent2 = (100 - this.percent1 - this.percent3);
            this.equipment = '';
            axios.post('/delete/equipment/sale', this.equipment_to_delete).then(res => {
                console.log(res.data);
            }).catch(error => {
                let array = {'msg': error.response.data.message};
                axios.post('/mail_error', array).then(res => {
                    console.log(res.data);
                });
                window.location.replace('/404');
            });

            axios.post('/update_sale', this._data).then(res => {
                console.log(res.data);
                window.location.reload();
            }).catch(error => {
                let array = {'msg': error.response.data.message};
                axios.post('/mail_error', array).then(res => {
                    console.log(res.data);
                });
                window.location.replace('/404');
            });
        },
        onFocus() {
            if (this.data_loading === true) {
                $(this.selected_equipment).each(function (i, v) {
                    this.data_loading = true;
                    if (v.pivot.price != v.price) {
                        v.discount = (100 - (v.pivot.price * 100 / v.price)).toFixed(5);
                    }

                    console.log(Number(v.last_price) + '  ' + Number(v.pivot.price) + '  ' + Number(v.price));
                    console.log();
                });
                setTimeout(() => {
                    this.data_loading = false;
                }, 500);
            }
        },

        set_discount_by_type() {
            $(this.selected_equipment).each(function (i, v) {
                v.discount = v.type_discount;
            })
        },

        set_discount_by_last_price() {
            $(this.selected_equipment).each(function (i, v) {
                if (v.last_price != v.price) {
                    v.discount = (100 - (v.last_price * 100 / v.price)).toFixed(4);
                }
            })
        },

        deleteSale() {
            // console.log('del'+this.$props.oid);
            if (confirm('Tikrai trinam?')) {
                axios.delete('/delete_sale/' + this.$props.sid).then(res => {
                    console.log(res.data);
                    window.location.replace('/customer/' + res.data)
                }).catch(error => {
                    let array = {'msg': error.response.data.message};
                    axios.post('/mail_error', array).then(res => {
                        console.log(res.data);
                    });
                    window.location.replace('/404');
                });
            }
        },
        getClass(p1, p2) {
            if (Number(p1) != Number(p2)) {
                // this.update_offer();
                return 'is-invalid';

            } else {
                return;
            }
        },

        enter_submit(e) {
            if (e.keyCode == 13) {
                console.log('enter');
                this.add_equipment_to_offer();
            }

        },

        renew_total(e) {
            var sum = 0;
            var sum_nv = 0;
            $.each(this.selected_equipment, function (i, v) {
                if (v.pivot.price > 0) {
                    sum += Math.round(((v.pivot.price * v.pivot.quantity) * 1.21) * 100) / 100;
                    sum_nv += Math.round(((v.pivot.price * v.pivot.quantity)) * 100) / 100;
                } else {
                    sum += Math.round((((v.price * v.pivot.quantity) * 1.21) * 100)) / 100;
                    sum_nv += Math.round((((v.price * v.pivot.quantity)) * 100)) / 100;
                }
            });
            console.log(sum);
            console.log(sum_nv);
            this.total = sum_nv;
            $(e.target).text(sum.toFixed(2) + '€')
        },

        setPriotity(se) {
            se.discount = (100 - (se.pivot.price * 100 / se.price)).toFixed(4)
            se.price_prio = 1;
        },

        edit_pivot_price(e) {
            $(e.target).closest(".col-6").hide();
            console.log($(e.target).attr('id'));
            $('#price-edit' + $(e.target).attr('id')).show();
            $('#discount' + $(e.target).attr('id')).attr('disabled', 'disabled');
        }

    }
}
</script>

<style scoped>

</style>
